
import { saveInstance, deleteInstance, updateInstance } from '../actions/modelActions';
import { store } from '../store';

export class BaseModel<P> {
    public static resource?: string;
    public resource?: string;
    public static props;
    constructor(public props: P & { id?: string }) {
        this.resource = this.constructor.resource;
        this.props = props;
    }

    public getStoreKey(): string {
        return `${this.resource}${this.props.id}`;
    }

    public $save(): BaseModel<P> {
        return saveInstance(this, this.getStoreKey(), this.resource);
    }

    public $saveAll(instances: BaseModel<P>[]): BaseModel<P>[] {
        instances.forEach((instance) => {
            saveInstance(this, this.getStoreKey(), this.resource);
        });
        return [];
    }

    public $delete(): BaseModel<P> {
        return deleteInstance(this.getStoreKey());
    }

    public $update(): BaseModel<P> {
        return updateInstance(this.getStoreKey(), this);
    }

    public static getSingleInstance<P>(id: string, state = store.getState()): BaseModel<P> {
        const storeKey: string = `${this.resource}${id}`;
        return state.models.toJS ? state.models.get(storeKey) : undefined;
    }

    public static listAll<P>(state = store.getState()): BaseModel<P>[] {
        return state
            .models
            .filter(instance => instance.resource === this.resource ? instance : '')
            .toArray()
            .reverse();
    }

    public static getAllIDs<P>(state = store.getState()): BaseModel<P>[] {
        return state
            .models
            .filter(instance => instance.resource === this.resource ? instance.props.id : '')
            .toArray();
    }

    public static deleteAllInstances<P>(state = store.getState()) {
        const ids = this.getAllIDs();
        state.models.forEach((instance, index) => {
            if (`${this.resource}${instance.props.id}` === index) {
                deleteInstance(index);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/BaseModel.ts